export function trackFunnelEvent(event: string, details: Record<string, unknown> = {}) {
    if (typeof window === "undefined") return;
    const payload = { event: `mockzo_${event}`, ...details };
    const target = window as Window & { dataLayer?: Array<Record<string, unknown>> };
    target.dataLayer?.push(payload);
    window.dispatchEvent(new CustomEvent("mockzo:funnel", { detail: payload }));
}
